import { useEffect, useState } from 'react';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { READ } from 'domain/shared/core/permissions';
import useExpectedCompensationService from './expectedCompensationService';
import { Show, useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import { SectionRow } from 'framework/ui/layout';
import { TextField } from 'framework/ui/field';
import IconButton from '@mui/material/IconButton';
import {
  CANDIDATE_TIMELINE_ICONS,
  CANDIDATE_TIMELINE_MESSAGE_CONTEXT,
  CANDIDATE_TIMELINE_RECORDS_ALIAS,
} from 'domain/shared/candidate';

type ExpectedCompensationLayoutProps = {
  onEdit: () => void;
  actionName: string;
};

const ExpectedCompensationLayout = ({ onEdit, ...props }: ExpectedCompensationLayoutProps) => {
  const { getById, getCompensationPermissions } = useExpectedCompensationService();

  const [isShown, setIsShown] = useState(false);

  const [isShownVisible, setIsShownVisible] = useState(false);

  const { data: entity } = useShowContext();

  const renderViewAction = () => {
    if (!isShownVisible) return null;

    return (
      <IconButton onClick={() => setIsShown(prev => !prev)}>
        {isShown ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
      </IconButton>
    );
  };
  useEffect(() => {
    (async () => {
      const permissions = await getCompensationPermissions(entity.compensationId);
      if (permissions.includes(READ)) {
        setIsShownVisible(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BasePersonTimelineRecordLayout
      permissionToCheck={READ}
      timelineType={CANDIDATE_TIMELINE_RECORDS_ALIAS.EXPECTED_COMPENSATION}
      artifactsSource="artifacts"
      buttons={[]}
      fields={
        <>
          <Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography>Expected compensation was added</Typography>

              {renderViewAction()}
            </Box>
            {isShown ? (
              <Show getDataMethod={() => getById(entity.compensationId)}>
                <Box display="flex" flexDirection="row">
                  <SectionRow
                    colXs={6}
                    colMd={3}
                    colXl={2}
                    spacing={1}
                    containerProps={{
                      sx: theme => ({
                        flex: 1,
                        '& .field-label': {
                          color: 'var(--mui-palette-primary-main) !important',
                          fontSize: '12px',
                          height: '20px',
                          [theme.breakpoints.down('xl')]: {
                            height: 'auto',
                          },
                        },
                      }),
                    }}
                  >
                    <TextField source="location" label="Location" />
                    <TextField source="currency" label="Currency" />
                    <TextField source="expectedAmountFrom" label="Amount From" />
                    <TextField source="expectedAmountTo" label="Amount To" />
                  </SectionRow>
                </Box>
              </Show>
            ) : null}
          </Box>
        </>
      }
      timelineIcons={CANDIDATE_TIMELINE_ICONS}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      {...props}
    />
  );
};

export default ExpectedCompensationLayout;
